import {
  type ProfileDto,
  type ProfileView,
} from "shared/mappers/database/profile/profile";
import { type ProfileAddressView } from "shared/mappers/database/profile/profile-address";

export type DefaultProfileAddressContactInformationSetting = {
  use?: string;
  type?: string;
};

//TODO: This is a bit temporary,  I'd rather the default email by set by an ID in society settings instead of this string ~ GS 8/16/23
export const defaultAddressFromProfile = ({
  profile,
  use,
  type,
  notBlankProperty,
}: {
  profile: ProfileDto | ProfileView | undefined;
  use?: "Billing" | "Shipping" | string;
  type?: "Postal" | "Physical" | string;
  notBlankProperty?:
    | "line1"
    | "line2"
    | "line3"
    | "city"
    | "state"
    | "country"
    | "region"
    | "postalCode";
}): ProfileAddressView | null => {
  return (
    profile?.address?.find((ci) => {
      if (
        use &&
        type &&
        ci.use?.some((ciUse) => ciUse.description == use) &&
        ci.type?.description === type
      ) {
        if (
          notBlankProperty &&
          (!ci[notBlankProperty] || ci[notBlankProperty] === "")
        ) {
          return false;
        }
        return true;
      }
      if (use && ci.use?.some((ciUse) => ciUse.description == use)) {
        if (
          notBlankProperty &&
          (!ci[notBlankProperty] || ci[notBlankProperty] === "")
        ) {
          return false;
        }
        return true;
      }
      if (type && ci.type?.description === type) {
        if (
          notBlankProperty &&
          (!ci[notBlankProperty] || ci[notBlankProperty] === "")
        ) {
          return false;
        }
        return true;
      }
      return false;
    }) ??
    (notBlankProperty
      ? profile?.address?.find(
          (ci) => ci[notBlankProperty] && ci[notBlankProperty] !== "",
        )
      : null) ??
    profile?.address?.[0] ??
    null
  );
};
